import { useAuth } from "../../contexts/AuthContext";

/**
 * Component-level permission guard
 * Conditionally renders children based on permission checks
 */
const PermissionGuard = ({
  children,
  permission,
  permissions,
  requireAll = false,
  fallback = null,
}) => {
  const { hasPermission, hasAnyPermission, hasAllPermissions } = useAuth();

  // Check single permission
  if (permission) {
    return hasPermission(permission) ? children : fallback;
  }

  // Check multiple permissions
  if (permissions) {
    const hasAccess = requireAll
      ? hasAllPermissions(permissions)
      : hasAnyPermission(permissions);

    return hasAccess ? children : fallback;
  }

  // If no permission specified, render children
  return children;
};

export default PermissionGuard;
